var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarAccent600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 1V23M12.3333 5H4.83325C3.90499 5 3.01476 5.36875 2.35838 6.02513C1.702 6.6815 1.33325 7.57174 1.33325 8.5C1.33325 9.42826 1.702 10.3185 2.35838 10.9749C3.01476 11.6313 3.90499 12 4.83325 12H9.83325C10.7615 12 11.6517 12.3687 12.3081 13.0251C12.9645 13.6815 13.3333 14.5717 13.3333 15.5C13.3333 16.4283 12.9645 17.3185 12.3081 17.9749C11.6517 18.6313 10.7615 19 9.83325 19H1.33325",
    stroke: "#648CE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarAccent600);
export default __webpack_public_path__ + "static/media/dollar-accent600.159e489bf676e1836f288abbad5b42d2.svg";
export { ForwardRef as ReactComponent };